import { Injectable, signal, computed, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { ToastService } from '../../../../trash/shared/components/toasters/Toast.service';
import { createValidationError, handleApiErrors } from '../../../../common';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  // Signal to track the online status
  private onlineStatusSignal = signal<boolean>(true); // Default to `true` for SSR compatibility

  constructor(
    private toastService: ToastService,
    @Inject(PLATFORM_ID) private platformId: object // Use @Inject to specify PLATFORM_ID
  ) {
    // Ensure the code runs only in the browser
    if (isPlatformBrowser(this.platformId)) {
      this.onlineStatusSignal.set(navigator.onLine); // Initialize with the real online status
      // Add event listeners for online and offline events
      window.addEventListener('online', () => this.updateOnlineStatus(true));
      window.addEventListener('offline', () => this.updateOnlineStatus(false));
    }
  }

  // Computed signal for derived state (if needed in the future)
  isOnline = computed(() => this.onlineStatusSignal());

  // Update the online status and show appropriate notifications
  private updateOnlineStatus(isOnline: boolean) {
    this.onlineStatusSignal.set(isOnline);

    if (isOnline) {
      this.toastService.showSuccess('Network status', 'You are back online.');
    } else {
      const validationError = createValidationError(
        'Network status',
        'You are offline.'
      );
      handleApiErrors(validationError, this.toastService);
    }
  }

  // Method to show an error when offline
  showOfflineRequestError() {
    const validationError = createValidationError(
      'Request status',
      'Request blocked: You are offline.'
    );
    handleApiErrors(validationError, this.toastService);
  }
}
